export enum PopupType {
  AccountCreated,
  ItemCreated,
  EmailNotVerified,
  EmailVerificationResent,
  HavingOldMarketplaceItems,
}

const toShowList = ref<Set<PopupType>>(new Set());

export function usePopupNotifications() {
  const show = (type: PopupType): void => {
    toShowList.value.add(type);
  };

  const markClosed = (type: PopupType): void => {
    toShowList.value.delete(type);
  };

  return {
    toShowList,
    show,
    markClosed,
  };
}
